import plugin from '@core/plugins/lib';
import { onAvailable } from "@core/plugins/lib/selectors";

const ELEMENT_SELECTOR = '[data-collapsible]';
const PLUGIN_NAME = 'Collapsible';

$(() => {
	onAvailable.ready(ELEMENT_SELECTOR, function (element) {
		System.import(
			/* webpackChunkName: "plugin--collapsible" */ "./collapsible.js"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__collapsible/plugin--split.js